import React from 'react';
import Skeleton from './Skeleton';

interface LoadingFallbackProps {
  isLoading?: boolean;
  children: React.ReactNode;
  skeletonClasses?: string;
}

function LoadingFallback({
  isLoading,
  children,
  skeletonClasses,
}: LoadingFallbackProps) {
  if (isLoading) {
    return <Skeleton className={skeletonClasses} />;
  }

  return <>{children}</>;
}

export default LoadingFallback;
